import React from 'react';
import { FileTextIcon, ClockIcon, AlertTriangleIcon } from 'lucide-react';
export function Background() {
  return <section id="hintergrund" className="py-16 bg-white" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center" data-id="element-18">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-19">
            Was steckt hinter §390 SGB V?
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-20">
            Die neuen IT-Sicherheitsanforderungen für Zahnarztpraxen im
            Überblick
          </p>
        </div>
        <div className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-21">
          <div className="bg-blue-50 rounded-lg p-6 shadow-sm" data-id="element-22">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-600 text-white mb-4" data-id="element-23">
              <FileTextIcon className="h-6 w-6" data-id="element-24" />
            </div>
            <h3 className="text-lg font-medium text-gray-900" data-id="element-25">Das Gesetz</h3>
            <p className="mt-2 text-gray-600" data-id="element-26">
              §390 SGB V definiert IT-Sicherheitsanforderungen für
              Zahnarztpraxen. Die KZBV hat dazu eine verbindliche Richtlinie
              erlassen: „Richtlinie nach §390 SGB V über die Anforderungen zur
              Gewährleistung der IT-Sicherheit".
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-6 shadow-sm" data-id="element-27">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-600 text-white mb-4" data-id="element-28">
              <ClockIcon className="h-6 w-6" data-id="element-29" />
            </div>
            <h3 className="text-lg font-medium text-gray-900" data-id="element-30">Der Zeitplan</h3>
            <p className="mt-2 text-gray-600" data-id="element-31">
              Juli 2025: Veröffentlichung der finalen Richtlinie
              <br data-id="element-32" />
              2. Januar 2026: Inkrafttreten der Richtlinie und Beginn der
              Prüfungen
              <br data-id="element-33" />
              Jetzt: Zeit für Vorbereitung und Umsetzung
            </p>
          </div>
          <div className="bg-blue-50 rounded-lg p-6 shadow-sm" data-id="element-34">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-600 text-white mb-4" data-id="element-35">
              <AlertTriangleIcon className="h-6 w-6" data-id="element-36" />
            </div>
            <h3 className="text-lg font-medium text-gray-900" data-id="element-37">
              Die Konsequenzen
            </h3>
            <p className="mt-2 text-gray-600" data-id="element-38">
              Bei Nichteinhaltung der Richtlinie drohen Praxen Sanktionen,
              mögliche Haftungsrisiken und Probleme mit der Kassenzulassung.
              Zudem besteht ein erhöhtes Risiko für Cyber-Angriffe und
              Datenschutzverletzungen.
            </p>
          </div>
        </div>
        <div className="mt-12 bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-39">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-40">
            Warum ist die Umsetzung so wichtig?
          </h3>
          <ul className="space-y-3 text-gray-600" data-id="element-41">
            <li className="flex items-start" data-id="element-42">
              <div className="flex-shrink-0" data-id="element-43">
                <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-44">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-45" />
                </svg>
              </div>
              <p className="ml-3" data-id="element-46">
                Schutz sensibler Patientendaten vor Cyber-Angriffen
              </p>
            </li>
            <li className="flex items-start" data-id="element-47">
              <div className="flex-shrink-0" data-id="element-48">
                <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-49">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-50" />
                </svg>
              </div>
              <p className="ml-3" data-id="element-51">Rechtssicherheit für Ihre Praxis</p>
            </li>
            <li className="flex items-start" data-id="element-52">
              <div className="flex-shrink-0" data-id="element-53">
                <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-54">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-55" />
                </svg>
              </div>
              <p className="ml-3" data-id="element-56">
                Vermeidung von Praxisausfällen durch IT-Sicherheitsvorfälle
              </p>
            </li>
            <li className="flex items-start" data-id="element-57">
              <div className="flex-shrink-0" data-id="element-58">
                <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-59">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-60" />
                </svg>
              </div>
              <p className="ml-3" data-id="element-61">
                Erhalt der Kassenzulassung und Absicherung des Praxisbetriebs
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}